import React, { useState } from 'react';
import VideoSection from './components/VideoSection';
import Rzr from './components/Rzr';
import Embeded from './components/Embeded';
import Prizes from './components/Prizes';
import GameBundle from './components/GameBundle';

const App = () => {
  const [allPrizesEnded, setAllPrizesEnded] = useState(false);

  const handleAllPrizesEnded = (ended) => {
    setAllPrizesEnded(ended);
  };


  return (
    <>
      <VideoSection />
      <div className="background pb-3">
        <Rzr allPrizesEnded={allPrizesEnded} />
        {!allPrizesEnded &&
          <>

            <Embeded />
            <GameBundle />
          </>
        }


        <Prizes onAllPrizesEnded={handleAllPrizesEnded} allPrizesEnded={allPrizesEnded} />


      </div>
    </>
  );
};

export default App;
